<template>
  <div>
    <a-select-field
      :formLayout="formLayout"
      :size="size"
      varName="recaptcha_options.captcha_widget"
      varLabel="Signing Algorithm"
      :varRequired="true"
      :varInitial="data.recaptcha_options.captcha_widget"
      :disabled="false"
      type="schema"
      :varOptions="Widgets"
    />
    <a-text-field
      varName="recaptcha_options.public_key"
      varLabel="Site Key"
      :varRequired="false"
      :varInitial="data.recaptcha_options.public_key"
      :formLayout="formLayout"
      :size="size"
      description="Site key for ReCaptcha V3 or V2. You must also provide Secret key."
    />
    <a-text-field
      varName="recaptcha_options.private_key"
      varLabel="Secret Key"
      :varRequired="false"
      :varInitial="data.recaptcha_options.private_key"
      :formLayout="formLayout"
      :size="size"
      description="Secret key for ReCaptcha V3 or V2. You must also provide Site key."
    />
    <a-number-field
      varName="recaptcha_options.required_score"
      varLabel="Required Score"
      :varRequired="true"
      :varInitial="data.recaptcha_options.required_score"
      :formLayout="formLayout"
      :size="size"
      :min="0"
      :max="1"
      :step="0.01"
      description="Required score for ReCaptcha V3"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      Widgets: [
        {
          value: "none",
          display_name: "No Captcha"
        },
        {
          value: "recaptcha_v2_check",
          display_name: "reCaptcha V2 Checkbox"
        },
        {
          value: "recaptcha_v3",
          display_name: "reCaptcha V3"
        }
      ]
    };
  },
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
};
</script>